import { CostCodeBase } from './base/cost-code-base';

export class CostCode extends CostCodeBase { }